import React from 'react';
import {Checkbox, FormControl, FormControlLabel, FormHelperText} from "material-ui";

export const renderCheckboxField = ({
                                        input,
                                        meta: {touched, error},
                                        ...custom
                                    }) => (

    <FormControl
        margin="normal"
        error={custom.err !== undefined && custom.err !== null}>

        {console.log(input)}

        <FormControlLabel
            control={
                <Checkbox
                    checked={input.value ? true : false}
                    onChange={input.onChange}
                    {...custom}
                />
            }
            label={custom.label}
        />
        {custom.err !== undefined && custom.err !== null ?
            custom.err.map((n, i) =>
                <FormHelperText key={i}>{n}</FormHelperText>) : null}
    </FormControl>
);


// WEBPACK FOOTER //
// ./src/forms/inputs/CheckboxFeaild.js